var AvatarUserBuilder = /** @class */ (function () {
    function AvatarUserBuilder() {
        this.user = {
            id: 'bboob0b0b0-boobob-obob00b0b-0b0b0b',
            firstName: 'bob',
            lastName: 'last',
            fullName: 'bob last',
            profileImage: '//www.traviscreekstables.com/img/img-horses02.jpg',
            isAgent: false
        };
    }
    AvatarUserBuilder.prototype.withId = function (id) {
        this.user.id = id;
        return this;
    };
    AvatarUserBuilder.prototype.withFirstName = function (firstName) {
        this.user.firstName = firstName;
        return this;
    };
    AvatarUserBuilder.prototype.withLastName = function (lastName) {
        this.user.lastName = lastName;
        return this;
    };
    AvatarUserBuilder.prototype.withFullName = function (fullName) {
        this.user.fullName = fullName;
        return this;
    };
    AvatarUserBuilder.prototype.withProfileImage = function (profileImage) {
        this.user.profileImage = profileImage;
        return this;
    };
    AvatarUserBuilder.prototype.withIsAgent = function (isAgent) {
        this.user.isAgent = isAgent;
        return this;
    };
    AvatarUserBuilder.prototype.withIsPartner = function (isPartner) {
        this.user.isPartner = isPartner;
        return this;
    };
    AvatarUserBuilder.prototype.build = function () {
        return this.user;
    };
    return AvatarUserBuilder;
}());
export { AvatarUserBuilder };
//# sourceMappingURL=avatar-user.js.map